import PropertyLeftListContainer from "../../../components/property/listing/PropertyLeftList";

const PropertyLeftList = () => {
  return <PropertyLeftListContainer />;
};

export default PropertyLeftList;
